import { action, computed, observable, makeObservable } from 'mobx';

import { PlanData, PlanQuery, PlanType } from 'chaika-frontend-types/frontend-cms';

import { SearchList } from '@store/abstract/SearchList';

import { PlanList } from './PlanList';
import { PlanVersionList } from './PlanVersionList';
import { PlanForm } from './PlanForm';

export class PlanStore {
    public static Name = 'planStore' as const;

    @observable public planList: PlanList = new PlanList();
    @observable public planVersionList: PlanVersionList = new PlanVersionList();
    @observable public searchList = new SearchList<PlanData, PlanData, PlanQuery>(PlanVersionList as any);
    @observable public planForm: PlanForm = new PlanForm();

    constructor() {
        makeObservable(this);
    }

    @computed
    public get isGuarantee() {
        const plan = this.planForm.serialize();
        return plan.type === PlanType.GuarantyLetterPlus || plan.type === PlanType.GuarantyLetter;
    }

    @action
    public reset(): void {
        this.planList.reset();
        this.planVersionList.reset();
        this.planForm = new PlanForm();
    }

    @action
    public setPlanForm(params: PlanData): void {
        this.planForm = new PlanForm(params);
    }

    public getListWithCount(): { plans: PlanData[]; count: number } {
        const list = this.searchList.searchParamsSet ? this.searchList : this.planVersionList;

        return {
            plans: list.values,
            count: list.count,
        };
    }

    public isGuaranteeLetterPlan(planId: string): boolean {
        const { type } = this.planList.getExisting(planId);

        return (
            type === PlanType.GuarantyLetter ||
            type === PlanType.GuarantyLetterPlus ||
            type === PlanType.WaitForGuarantyLetter
        );
    }
}

export const planStore = new PlanStore();
